function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var z = {},
    J;

function F() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  z = _objectSpread({
    animate: !0,
    allowClose: !0,
    overlayClickBehavior: "close",
    overlayOpacity: 0.7,
    smoothScroll: !1,
    disableActiveInteraction: !1,
    showProgress: !1,
    stagePadding: 10,
    stageRadius: 5,
    popoverOffset: 10,
    showButtons: ["next", "previous", "close"],
    disableButtons: [],
    overlayColor: "#000"
  }, e);
}

function s(e) {
  return e ? z[e] : z;
}

function le(e) {
  J = e;
}

function _() {
  return J;
}

var I = {};

function N(e, o) {
  I[e] = o;
}

function E(e) {
  var o;
  (o = I[e]) == null || o.call(I);
}

function de() {
  I = {};
}

function O(e, o, t, i) {
  return (e /= i / 2) < 1 ? t / 2 * e * e + o : -t / 2 * (--e * (e - 2) - 1) + o;
}

function U(e) {
  var o = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';
  return e.flatMap(function (t) {
    var i = t.matches(o),
        d = Array.from(t.querySelectorAll(o));
    return [].concat(_toConsumableArray(i ? [t] : []), _toConsumableArray(d));
  }).filter(function (t) {
    return getComputedStyle(t).pointerEvents !== "none" && ve(t);
  });
}

function ee(e) {
  if (!e || ue(e)) return;
  var o = s("smoothScroll"),
      t = e.offsetHeight > window.innerHeight;
  e.scrollIntoView({
    // Removing the smooth scrolling for elements which exist inside the scrollable parent
    // This was causing the highlight to not properly render
    behavior: !o || pe(e) ? "auto" : "smooth",
    inline: "center",
    block: t ? "start" : "center"
  });
}

function pe(e) {
  if (!e || !e.parentElement) return;
  var o = e.parentElement;
  return o.scrollHeight > o.clientHeight;
}

function ue(e) {
  var o = e.getBoundingClientRect();
  return o.top >= 0 && o.left >= 0 && o.bottom <= (window.innerHeight || document.documentElement.clientHeight) && o.right <= (window.innerWidth || document.documentElement.clientWidth);
}

function ve(e) {
  return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
}

var D = {};

function k(e, o) {
  D[e] = o;
}

function l(e) {
  return e ? D[e] : D;
}

function X() {
  D = {};
}

function fe(e, o, t, i) {
  var d = l("__activeStagePosition");
  var n = d || t.getBoundingClientRect(),
      f = i.getBoundingClientRect(),
      w = O(e, n.x, f.x - n.x, o),
      r = O(e, n.y, f.y - n.y, o),
      v = O(e, n.width, f.width - n.width, o),
      g = O(e, n.height, f.height - n.height, o);
  d = {
    x: w,
    y: r,
    width: v,
    height: g
  }, oe(d), k("__activeStagePosition", d);
}

function te(e) {
  if (!e) return;
  var o = e.getBoundingClientRect(),
      t = {
    x: o.x,
    y: o.y,
    width: o.width,
    height: o.height
  };
  k("__activeStagePosition", t), oe(t);
}

function he() {
  var e = l("__activeStagePosition"),
      o = l("__overlaySvg");
  if (!e) return;

  if (!o) {
    console.warn("No stage svg found.");
    return;
  }

  var t = window.innerWidth,
      i = window.innerHeight;
  o.setAttribute("viewBox", "0 0 ".concat(t, " ").concat(i));
}

function ge(e) {
  var o = we(e);
  document.body.appendChild(o), re(o, function (t) {
    t.target.tagName === "path" && E("overlayClick");
  }), k("__overlaySvg", o);
}

function oe(e) {
  var o = l("__overlaySvg");

  if (!o) {
    ge(e);
    return;
  }

  var t = o.firstElementChild;
  if ((t == null ? void 0 : t.tagName) !== "path") throw new Error("no path element found in stage svg");
  t.setAttribute("d", ie(e));
}

function we(e) {
  var o = window.innerWidth,
      t = window.innerHeight,
      i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  i.classList.add("driver-overlay", "driver-overlay-animated"), i.setAttribute("viewBox", "0 0 ".concat(o, " ").concat(t)), i.setAttribute("xmlSpace", "preserve"), i.setAttribute("xmlnsXlink", "http://www.w3.org/1999/xlink"), i.setAttribute("version", "1.1"), i.setAttribute("preserveAspectRatio", "xMinYMin slice"), i.style.fillRule = "evenodd", i.style.clipRule = "evenodd", i.style.strokeLinejoin = "round", i.style.strokeMiterlimit = "2", i.style.zIndex = "10000", i.style.position = "fixed", i.style.top = "0", i.style.left = "0", i.style.width = "100%", i.style.height = "100%";
  var d = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return d.setAttribute("d", ie(e)), d.style.fill = s("overlayColor") || "rgb(0,0,0)", d.style.opacity = "".concat(s("overlayOpacity")), d.style.pointerEvents = "auto", d.style.cursor = "auto", i.appendChild(d), i;
}

function ie(e) {
  var o = window.innerWidth,
      t = window.innerHeight,
      i = s("stagePadding") || 0,
      d = s("stageRadius") || 0,
      n = e.width + i * 2,
      f = e.height + i * 2,
      w = Math.min(d, n / 2, f / 2),
      r = Math.floor(Math.max(w, 0)),
      v = e.x - i + r,
      g = e.y - i,
      y = n - r * 2,
      a = f - r * 2;
  return "M".concat(o, ",0L0,0L0,").concat(t, "L").concat(o, ",").concat(t, "L").concat(o, ",0Z\n    M").concat(v, ",").concat(g, " h").concat(y, " a").concat(r, ",").concat(r, " 0 0 1 ").concat(r, ",").concat(r, " v").concat(a, " a").concat(r, ",").concat(r, " 0 0 1 -").concat(r, ",").concat(r, " h-").concat(y, " a").concat(r, ",").concat(r, " 0 0 1 -").concat(r, ",-").concat(r, " v-").concat(a, " a").concat(r, ",").concat(r, " 0 0 1 ").concat(r, ",-").concat(r, " z");
}

function me() {
  var e = l("__overlaySvg");
  e && e.remove();
}

function ye() {
  var e = document.getElementById("driver-dummy-element");
  if (e) return e;
  var o = document.createElement("div");
  return o.id = "driver-dummy-element", o.style.width = "0", o.style.height = "0", o.style.pointerEvents = "none", o.style.opacity = "0", o.style.position = "fixed", o.style.top = "50%", o.style.left = "50%", document.body.appendChild(o), o;
}

function j(e) {
  var o = e.element;
  var t = typeof o == "function" ? o() : typeof o == "string" ? document.querySelector(o) : o;
  t || (t = ye()), be(t, e);
}

function xe() {
  var e = l("__activeElement"),
      o = l("__activeStep");
  e && (te(e), he(), ae(e, o));
}

function be(e, o) {
  var C;
  var i = Date.now(),
      d = l("__activeStep"),
      n = l("__activeElement") || e,
      f = !n || n === e,
      w = e.id === "driver-dummy-element",
      r = n.id === "driver-dummy-element",
      v = s("animate"),
      g = o.onHighlightStarted || s("onHighlightStarted"),
      y = (o == null ? void 0 : o.onHighlighted) || s("onHighlighted"),
      a = (d == null ? void 0 : d.onDeselected) || s("onDeselected"),
      p = s(),
      c = l();
  !f && a && a(r ? void 0 : n, d, {
    config: p,
    state: c,
    driver: _()
  }), g && g(w ? void 0 : e, o, {
    config: p,
    state: c,
    driver: _()
  });
  var u = !f && v;
  var h = !1;
  _e(), k("previousStep", d), k("previousElement", n), k("activeStep", o), k("activeElement", e);

  var m = function m() {
    if (l("__transitionCallback") !== m) return;
    var b = Date.now() - i,
        L = 400 - b <= 400 / 2;
    o.popover && L && !h && u && (Q(e, o), h = !0), s("animate") && b < 400 ? fe(b, 400, n, e) : (te(e), y && y(w ? void 0 : e, o, {
      config: s(),
      state: l(),
      driver: _()
    }), k("__transitionCallback", void 0), k("__previousStep", d), k("__previousElement", n), k("__activeStep", o), k("__activeElement", e)), window.requestAnimationFrame(m);
  };

  k("__transitionCallback", m), window.requestAnimationFrame(m), ee(e), !u && o.popover && Q(e, o), n.classList.remove("driver-active-element", "driver-no-interaction"), n.removeAttribute("aria-haspopup"), n.removeAttribute("aria-expanded"), n.removeAttribute("aria-controls"), ((C = o.disableActiveInteraction) != null ? C : s("disableActiveInteraction")) && e.classList.add("driver-no-interaction"), e.classList.add("driver-active-element"), e.setAttribute("aria-haspopup", "dialog"), e.setAttribute("aria-expanded", "true"), e.setAttribute("aria-controls", "driver-popover-content");
}

function Ce() {
  var e;
  (e = document.getElementById("driver-dummy-element")) == null || e.remove(), document.querySelectorAll(".driver-active-element").forEach(function (o) {
    o.classList.remove("driver-active-element", "driver-no-interaction"), o.removeAttribute("aria-haspopup"), o.removeAttribute("aria-expanded"), o.removeAttribute("aria-controls");
  });
}

function M() {
  var e = l("__resizeTimeout");
  e && window.cancelAnimationFrame(e), k("__resizeTimeout", window.requestAnimationFrame(xe));
}

function Pe(e) {
  var r;
  if (!l("isInitialized") || !(e.key === "Tab" || e.keyCode === 9)) return;
  var i = l("__activeElement"),
      d = (r = l("popover")) == null ? void 0 : r.wrapper,
      n = U([].concat(_toConsumableArray(d ? [d] : []), _toConsumableArray(i ? [i] : []))),
      f = n[0],
      w = n[n.length - 1];

  if (e.preventDefault(), e.shiftKey) {
    var v = n[n.indexOf(document.activeElement) - 1] || w;
    v == null || v.focus();
  } else {
    var _v = n[n.indexOf(document.activeElement) + 1] || f;

    _v == null || _v.focus();
  }
}

function ne(e) {
  var t;
  ((t = s("allowKeyboardControl")) == null || t) && (e.key === "Escape" ? E("escapePress") : e.key === "ArrowRight" ? E("arrowRightPress") : e.key === "ArrowLeft" && E("arrowLeftPress"));
}

function re(e, o, t) {
  var i = function i(n, f) {
    var w = n.target;
    e.contains(w) && ((!t || t(w)) && (n.preventDefault(), n.stopPropagation(), n.stopImmediatePropagation()), f == null || f(n));
  };

  document.addEventListener("pointerdown", i, !0), document.addEventListener("mousedown", i, !0), document.addEventListener("pointerup", i, !0), document.addEventListener("mouseup", i, !0), document.addEventListener("click", function (n) {
    i(n, o);
  }, !0);
}

function ke() {
  window.addEventListener("keyup", ne, !1), window.addEventListener("keydown", Pe, !1), window.addEventListener("resize", M), window.addEventListener("scroll", M);
}

function Se() {
  window.removeEventListener("keyup", ne), window.removeEventListener("resize", M), window.removeEventListener("scroll", M);
}

function _e() {
  var e = l("popover");
  e && (e.wrapper.style.display = "none");
}

function Q(e, o) {
  var b, P;
  var t = l("popover");
  t && document.body.removeChild(t.wrapper), t = Ee(), document.body.appendChild(t.wrapper);

  var _ref = o.popover || {},
      i = _ref.title,
      d = _ref.description,
      n = _ref.showButtons,
      f = _ref.disableButtons,
      w = _ref.showProgress,
      _ref$nextBtnText = _ref.nextBtnText,
      r = _ref$nextBtnText === void 0 ? s("nextBtnText") || "Next &rarr;" : _ref$nextBtnText,
      _ref$prevBtnText = _ref.prevBtnText,
      v = _ref$prevBtnText === void 0 ? s("prevBtnText") || "&larr; Previous" : _ref$prevBtnText,
      _ref$progressText = _ref.progressText,
      g = _ref$progressText === void 0 ? s("progressText") || "{current} of {total}" : _ref$progressText;

  t.nextButton.innerHTML = r, t.previousButton.innerHTML = v, t.progress.innerHTML = g, i ? (t.title.innerHTML = i, t.title.style.display = "block") : t.title.style.display = "none", d ? (t.description.innerHTML = d, t.description.style.display = "block") : t.description.style.display = "none";
  var y = n || s("showButtons"),
      a = w || s("showProgress") || !1,
      p = (y == null ? void 0 : y.includes("next")) || (y == null ? void 0 : y.includes("previous")) || a;
  t.closeButton.style.display = y.includes("close") ? "block" : "none", p ? (t.footer.style.display = "flex", t.progress.style.display = a ? "block" : "none", t.nextButton.style.display = y.includes("next") ? "block" : "none", t.previousButton.style.display = y.includes("previous") ? "block" : "none") : t.footer.style.display = "none";
  var c = f || s("disableButtons") || [];
  c != null && c.includes("next") && (t.nextButton.disabled = !0, t.nextButton.classList.add("driver-popover-btn-disabled")), c != null && c.includes("previous") && (t.previousButton.disabled = !0, t.previousButton.classList.add("driver-popover-btn-disabled")), c != null && c.includes("close") && (t.closeButton.disabled = !0, t.closeButton.classList.add("driver-popover-btn-disabled"));
  var u = t.wrapper;
  u.style.display = "block", u.style.left = "", u.style.top = "", u.style.bottom = "", u.style.right = "", u.id = "driver-popover-content", u.setAttribute("role", "dialog"), u.setAttribute("aria-labelledby", "driver-popover-title"), u.setAttribute("aria-describedby", "driver-popover-description");
  var h = t.arrow;
  h.className = "driver-popover-arrow";
  var m = ((b = o.popover) == null ? void 0 : b.popoverClass) || s("popoverClass") || "";
  u.className = "driver-popover ".concat(m).trim(), re(t.wrapper, function (L) {
    var B, R, W;
    var T = L.target,
        A = ((B = o.popover) == null ? void 0 : B.onNextClick) || s("onNextClick"),
        H = ((R = o.popover) == null ? void 0 : R.onPrevClick) || s("onPrevClick"),
        $ = ((W = o.popover) == null ? void 0 : W.onCloseClick) || s("onCloseClick");
    if (T.classList.contains("driver-popover-next-btn")) return A ? A(e, o, {
      config: s(),
      state: l(),
      driver: _()
    }) : E("nextClick");
    if (T.classList.contains("driver-popover-prev-btn")) return H ? H(e, o, {
      config: s(),
      state: l(),
      driver: _()
    }) : E("prevClick");
    if (T.classList.contains("driver-popover-close-btn")) return $ ? $(e, o, {
      config: s(),
      state: l(),
      driver: _()
    }) : E("closeClick");
  }, function (L) {
    return !(t != null && t.description.contains(L)) && !(t != null && t.title.contains(L)) && typeof L.className == "string" && L.className.includes("driver-popover");
  }), k("popover", t);
  var x = ((P = o.popover) == null ? void 0 : P.onPopoverRender) || s("onPopoverRender");
  x && x(t, {
    config: s(),
    state: l(),
    driver: _()
  }), ae(e, o), ee(u);
  var C = e.classList.contains("driver-dummy-element"),
      S = U([u].concat(_toConsumableArray(C ? [] : [e])));
  S.length > 0 && S[0].focus();
}

function se() {
  var e = l("popover");
  if (!(e != null && e.wrapper)) return;
  var o = e.wrapper.getBoundingClientRect(),
      t = s("stagePadding") || 0,
      i = s("popoverOffset") || 0;
  return {
    width: o.width + t + i,
    height: o.height + t + i,
    realWidth: o.width,
    realHeight: o.height
  };
}

function Z(e, o) {
  var t = o.elementDimensions,
      i = o.popoverDimensions,
      d = o.popoverPadding,
      n = o.popoverArrowDimensions;
  return e === "start" ? Math.max(Math.min(t.top - d, window.innerHeight - i.realHeight - n.width), n.width) : e === "end" ? Math.max(Math.min(t.top - (i == null ? void 0 : i.realHeight) + t.height + d, window.innerHeight - (i == null ? void 0 : i.realHeight) - n.width), n.width) : e === "center" ? Math.max(Math.min(t.top + t.height / 2 - (i == null ? void 0 : i.realHeight) / 2, window.innerHeight - (i == null ? void 0 : i.realHeight) - n.width), n.width) : 0;
}

function G(e, o) {
  var t = o.elementDimensions,
      i = o.popoverDimensions,
      d = o.popoverPadding,
      n = o.popoverArrowDimensions;
  return e === "start" ? Math.max(Math.min(t.left - d, window.innerWidth - i.realWidth - n.width), n.width) : e === "end" ? Math.max(Math.min(t.left - (i == null ? void 0 : i.realWidth) + t.width + d, window.innerWidth - (i == null ? void 0 : i.realWidth) - n.width), n.width) : e === "center" ? Math.max(Math.min(t.left + t.width / 2 - (i == null ? void 0 : i.realWidth) / 2, window.innerWidth - (i == null ? void 0 : i.realWidth) - n.width), n.width) : 0;
}

function ae(e, o) {
  var t = l("popover");
  if (!t) return;

  var _ref2 = (o == null ? void 0 : o.popover) || {},
      _ref2$align = _ref2.align,
      i = _ref2$align === void 0 ? "start" : _ref2$align,
      _ref2$side = _ref2.side,
      d = _ref2$side === void 0 ? "left" : _ref2$side,
      n = i,
      f = e.id === "driver-dummy-element" ? "over" : d,
      w = s("stagePadding") || 0,
      r = se(),
      v = t.arrow.getBoundingClientRect(),
      g = e.getBoundingClientRect(),
      y = g.top - r.height;

  var a = y >= 0;
  var p = window.innerHeight - (g.bottom + r.height);
  var c = p >= 0;
  var u = g.left - r.width;
  var h = u >= 0;
  var m = window.innerWidth - (g.right + r.width);
  var x = m >= 0;
  var C = !a && !c && !h && !x;
  var S = f;

  if (f === "top" && a ? x = h = c = !1 : f === "bottom" && c ? x = h = a = !1 : f === "left" && h ? x = a = c = !1 : f === "right" && x && (h = a = c = !1), f === "over") {
    var b = window.innerWidth / 2 - r.realWidth / 2,
        P = window.innerHeight / 2 - r.realHeight / 2;
    t.wrapper.style.left = "".concat(b, "px"), t.wrapper.style.right = "auto", t.wrapper.style.top = "".concat(P, "px"), t.wrapper.style.bottom = "auto";
  } else if (C) {
    var _b = window.innerWidth / 2 - (r == null ? void 0 : r.realWidth) / 2,
        _P = 10;

    t.wrapper.style.left = "".concat(_b, "px"), t.wrapper.style.right = "auto", t.wrapper.style.bottom = "".concat(_P, "px"), t.wrapper.style.top = "auto";
  } else if (h) {
    var _b2 = Math.min(u, window.innerWidth - (r == null ? void 0 : r.realWidth) - v.width),
        _P2 = Z(n, {
      elementDimensions: g,
      popoverDimensions: r,
      popoverPadding: w,
      popoverArrowDimensions: v
    });

    t.wrapper.style.left = "".concat(_b2, "px"), t.wrapper.style.top = "".concat(_P2, "px"), t.wrapper.style.bottom = "auto", t.wrapper.style.right = "auto", S = "left";
  } else if (x) {
    var _b3 = Math.min(m, window.innerWidth - (r == null ? void 0 : r.realWidth) - v.width),
        _P3 = Z(n, {
      elementDimensions: g,
      popoverDimensions: r,
      popoverPadding: w,
      popoverArrowDimensions: v
    });

    t.wrapper.style.right = "".concat(_b3, "px"), t.wrapper.style.top = "".concat(_P3, "px"), t.wrapper.style.bottom = "auto", t.wrapper.style.left = "auto", S = "right";
  } else if (a) {
    var _b4 = Math.min(y, window.innerHeight - r.realHeight - v.width);

    var _P4 = G(n, {
      elementDimensions: g,
      popoverDimensions: r,
      popoverPadding: w,
      popoverArrowDimensions: v
    });

    t.wrapper.style.top = "".concat(_b4, "px"), t.wrapper.style.left = "".concat(_P4, "px"), t.wrapper.style.bottom = "auto", t.wrapper.style.right = "auto", S = "top";
  } else if (c) {
    var _b5 = Math.min(p, window.innerHeight - (r == null ? void 0 : r.realHeight) - v.width);

    var _P5 = G(n, {
      elementDimensions: g,
      popoverDimensions: r,
      popoverPadding: w,
      popoverArrowDimensions: v
    });

    t.wrapper.style.left = "".concat(_P5, "px"), t.wrapper.style.bottom = "".concat(_b5, "px"), t.wrapper.style.top = "auto", t.wrapper.style.right = "auto", S = "bottom";
  }

  C ? t.arrow.classList.add("driver-popover-arrow-none") : Le(n, S, e);
}

function Le(e, o, t) {
  var i = l("popover");
  if (!i) return;
  var d = t.getBoundingClientRect(),
      n = se(),
      f = i.arrow,
      w = n.width,
      r = window.innerWidth,
      v = d.width,
      g = d.left,
      y = n.height,
      a = window.innerHeight,
      p = d.top,
      c = d.height;
  f.className = "driver-popover-arrow";
  var u = o,
      h = e;
  if (o === "top" ? (g + v <= 0 ? (u = "right", h = "end") : g + v - w <= 0 && (u = "top", h = "start"), g >= r ? (u = "left", h = "end") : g + w >= r && (u = "top", h = "end")) : o === "bottom" ? (g + v <= 0 ? (u = "right", h = "start") : g + v - w <= 0 && (u = "bottom", h = "start"), g >= r ? (u = "left", h = "start") : g + w >= r && (u = "bottom", h = "end")) : o === "left" ? (p + c <= 0 ? (u = "bottom", h = "end") : p + c - y <= 0 && (u = "left", h = "start"), p >= a ? (u = "top", h = "end") : p + y >= a && (u = "left", h = "end")) : o === "right" && (p + c <= 0 ? (u = "bottom", h = "start") : p + c - y <= 0 && (u = "right", h = "start"), p >= a ? (u = "top", h = "start") : p + y >= a && (u = "right", h = "end")), !u) f.classList.add("driver-popover-arrow-none");else {
    f.classList.add("driver-popover-arrow-side-".concat(u)), f.classList.add("driver-popover-arrow-align-".concat(h));
    var m = t.getBoundingClientRect(),
        x = f.getBoundingClientRect(),
        C = s("stagePadding") || 0,
        S = m.left - C < window.innerWidth && m.right + C > 0 && m.top - C < window.innerHeight && m.bottom + C > 0;
    o === "bottom" && S && (x.x > m.x && x.x + x.width < m.x + m.width ? i.wrapper.style.transform = "translateY(0)" : (f.classList.remove("driver-popover-arrow-align-".concat(h)), f.classList.add("driver-popover-arrow-none"), i.wrapper.style.transform = "translateY(-".concat(C / 2, "px)")));
  }
}

function Ee() {
  var e = document.createElement("div");
  e.classList.add("driver-popover");
  var o = document.createElement("div");
  o.classList.add("driver-popover-arrow");
  var t = document.createElement("header");
  t.id = "driver-popover-title", t.classList.add("driver-popover-title"), t.style.display = "none", t.innerText = "Popover Title";
  var i = document.createElement("div");
  i.id = "driver-popover-description", i.classList.add("driver-popover-description"), i.style.display = "none", i.innerText = "Popover description is here";
  var d = document.createElement("button");
  d.type = "button", d.classList.add("driver-popover-close-btn"), d.setAttribute("aria-label", "Close"), d.innerHTML = "&times;";
  var n = document.createElement("footer");
  n.classList.add("driver-popover-footer");
  var f = document.createElement("span");
  f.classList.add("driver-popover-progress-text"), f.innerText = "";
  var w = document.createElement("span");
  w.classList.add("driver-popover-navigation-btns");
  var r = document.createElement("button");
  r.type = "button", r.classList.add("driver-popover-prev-btn"), r.innerHTML = "&larr; Previous";
  var v = document.createElement("button");
  return v.type = "button", v.classList.add("driver-popover-next-btn"), v.innerHTML = "Next &rarr;", w.appendChild(r), w.appendChild(v), n.appendChild(f), n.appendChild(w), e.appendChild(d), e.appendChild(o), e.appendChild(t), e.appendChild(i), e.appendChild(n), {
    wrapper: e,
    arrow: o,
    title: t,
    description: i,
    footer: n,
    previousButton: r,
    nextButton: v,
    closeButton: d,
    footerButtons: w,
    progress: f
  };
}

function Te() {
  var o;
  var e = l("popover");
  e && ((o = e.wrapper.parentElement) == null || o.removeChild(e.wrapper));
}

function Ae() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  F(e);

  function o() {
    s("allowClose") && g();
  }

  function t() {
    var a = s("overlayClickBehavior");

    if (s("allowClose") && a === "close") {
      g();
      return;
    }

    a === "nextStep" && i();
  }

  function i() {
    var a = l("activeIndex"),
        p = s("steps") || [];
    if (typeof a == "undefined") return;
    var c = a + 1;
    p[c] ? v(c) : g();
  }

  function d() {
    var a = l("activeIndex"),
        p = s("steps") || [];
    if (typeof a == "undefined") return;
    var c = a - 1;
    p[c] ? v(c) : g();
  }

  function n(a) {
    (s("steps") || [])[a] ? v(a) : g();
  }

  function f() {
    var x;
    if (l("__transitionCallback")) return;
    var p = l("activeIndex"),
        c = l("__activeStep"),
        u = l("__activeElement");
    if (typeof p == "undefined" || typeof c == "undefined" || typeof l("activeIndex") == "undefined") return;
    var m = ((x = c.popover) == null ? void 0 : x.onPrevClick) || s("onPrevClick");
    if (m) return m(u, c, {
      config: s(),
      state: l(),
      driver: _()
    });
    d();
  }

  function w() {
    var m;
    if (l("__transitionCallback")) return;
    var p = l("activeIndex"),
        c = l("__activeStep"),
        u = l("__activeElement");
    if (typeof p == "undefined" || typeof c == "undefined") return;
    var h = ((m = c.popover) == null ? void 0 : m.onNextClick) || s("onNextClick");
    if (h) return h(u, c, {
      config: s(),
      state: l(),
      driver: _()
    });
    i();
  }

  function r() {
    l("isInitialized") || (k("isInitialized", !0), document.body.classList.add("driver-active", s("animate") ? "driver-fade" : "driver-simple"), ke(), N("overlayClick", t), N("escapePress", o), N("arrowLeftPress", f), N("arrowRightPress", w));
  }

  function v() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var $, B, R, W, V, q, K, Y;
    var p = s("steps");

    if (!p) {
      console.error("No steps to drive through"), g();
      return;
    }

    if (!p[a]) {
      g();
      return;
    }

    k("__activeOnDestroyed", document.activeElement), k("activeIndex", a);
    var c = p[a],
        u = p[a + 1],
        h = p[a - 1],
        m = (($ = c.popover) == null ? void 0 : $.doneBtnText) || s("doneBtnText") || "Done",
        x = s("allowClose"),
        C = typeof ((B = c.popover) == null ? void 0 : B.showProgress) != "undefined" ? (R = c.popover) == null ? void 0 : R.showProgress : s("showProgress"),
        b = (((W = c.popover) == null ? void 0 : W.progressText) || s("progressText") || "{{current}} of {{total}}").replace("{{current}}", "".concat(a + 1)).replace("{{total}}", "".concat(p.length)),
        P = ((V = c.popover) == null ? void 0 : V.showButtons) || s("showButtons"),
        L = ["next", "previous"].concat(_toConsumableArray(x ? ["close"] : [])).filter(function (ce) {
      return !(P != null && P.length) || P.includes(ce);
    }),
        T = ((q = c.popover) == null ? void 0 : q.onNextClick) || s("onNextClick"),
        A = ((K = c.popover) == null ? void 0 : K.onPrevClick) || s("onPrevClick"),
        H = ((Y = c.popover) == null ? void 0 : Y.onCloseClick) || s("onCloseClick");
    j(_objectSpread(_objectSpread({}, c), {}, {
      popover: _objectSpread({
        showButtons: L,
        nextBtnText: u ? void 0 : m,
        disableButtons: _toConsumableArray(h ? [] : ["previous"]),
        showProgress: C,
        progressText: b,
        onNextClick: T || function () {
          u ? v(a + 1) : g();
        },
        onPrevClick: A || function () {
          v(a - 1);
        },
        onCloseClick: H || function () {
          g();
        }
      }, (c == null ? void 0 : c.popover) || {})
    }));
  }

  function g() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    var p = l("__activeElement"),
        c = l("__activeStep"),
        u = l("__activeOnDestroyed"),
        h = s("onDestroyStarted");

    if (a && h) {
      var C = !p || (p == null ? void 0 : p.id) === "driver-dummy-element";
      h(C ? void 0 : p, c, {
        config: s(),
        state: l(),
        driver: _()
      });
      return;
    }

    var m = (c == null ? void 0 : c.onDeselected) || s("onDeselected"),
        x = s("onDestroyed");

    if (document.body.classList.remove("driver-active", "driver-fade", "driver-simple"), Se(), Te(), Ce(), me(), de(), X(), p && c) {
      var _C = p.id === "driver-dummy-element";

      m && m(_C ? void 0 : p, c, {
        config: s(),
        state: l(),
        driver: _()
      }), x && x(_C ? void 0 : p, c, {
        config: s(),
        state: l(),
        driver: _()
      });
    }

    u && u.focus();
  }

  var y = {
    isActive: function isActive() {
      return l("isInitialized") || !1;
    },
    refresh: M,
    drive: function drive() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      r(), v(a);
    },
    setConfig: F,
    setSteps: function setSteps(a) {
      X(), F(_objectSpread(_objectSpread({}, s()), {}, {
        steps: a
      }));
    },
    getConfig: s,
    getState: l,
    getActiveIndex: function getActiveIndex() {
      return l("activeIndex");
    },
    isFirstStep: function isFirstStep() {
      return l("activeIndex") === 0;
    },
    isLastStep: function isLastStep() {
      var a = s("steps") || [],
          p = l("activeIndex");
      return p !== void 0 && p === a.length - 1;
    },
    getActiveStep: function getActiveStep() {
      return l("activeStep");
    },
    getActiveElement: function getActiveElement() {
      return l("activeElement");
    },
    getPreviousElement: function getPreviousElement() {
      return l("previousElement");
    },
    getPreviousStep: function getPreviousStep() {
      return l("previousStep");
    },
    moveNext: i,
    movePrevious: d,
    moveTo: n,
    hasNextStep: function hasNextStep() {
      var a = s("steps") || [],
          p = l("activeIndex");
      return p !== void 0 && !!a[p + 1];
    },
    hasPreviousStep: function hasPreviousStep() {
      var a = s("steps") || [],
          p = l("activeIndex");
      return p !== void 0 && !!a[p - 1];
    },
    highlight: function highlight(a) {
      r(), j(_objectSpread(_objectSpread({}, a), {}, {
        popover: a.popover ? _objectSpread({
          showButtons: [],
          showProgress: !1,
          progressText: ""
        }, a.popover) : void 0
      }));
    },
    destroy: function destroy() {
      g(!1);
    }
  };
  return le(y), y;
}

export { Ae as driver };